module.exports = __webpack_public_path__ + "static/cartier.1c1c48be.mp4";


//////////////////
// WEBPACK FOOTER
// ./videos/cartier.mp4
// module id = 808
// module chunks = 107119748094653